<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <span :class="b('icon')" aria-hidden="true">
      <slot name="icon">i</slot>
    </span>

    <div :class="b('content')">
      <slot></slot>
    </div>
  </div>
</template>
